module.exports = __webpack_public_path__ + "img/icon9.7101992a.svg";